import { __module as v } from "./ghl-ui.es1730.js";
import { i as g } from "./ghl-ui.es1541.js";
import { g as E } from "./ghl-ui.es1688.js";
import { r as $ } from "./ghl-ui.es1637.js";
import { s as Y } from "./ghl-ui.es1710.js";
import { t as q } from "./ghl-ui.es1636.js";
import "./ghl-ui.es1638.js";
import { __exports as y } from "./ghl-ui.es1641.js";
(function(_, r) {
  var t = g.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = O;
  var m = t(E), x = t($), C = t(Y), k = t(q), W = y;
  function O(c, e) {
    var a, o, i, l, s, n, f, d;
    (0, x.default)(1, arguments);
    var p = (0, W.getDefaultOptions)(), D = (0, k.default)((a = (o = (i = (l = e == null ? void 0 : e.firstWeekContainsDate) !== null && l !== void 0 ? l : e == null || (s = e.locale) === null || s === void 0 || (n = s.options) === null || n === void 0 ? void 0 : n.firstWeekContainsDate) !== null && i !== void 0 ? i : p.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = p.locale) === null || f === void 0 || (d = f.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), T = (0, m.default)(c, e), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(T, 0, D), u.setUTCHours(0, 0, 0, 0);
    var U = (0, C.default)(u, e);
    return U;
  }
  _.exports = r.default;
})(v, v.exports);
var M = v.exports;
export {
  M as s
};
